import { delayAction } from "./delay_action";
import { dom } from "./dom";
const main = dom("main");
export { main };
let eventDeregisterList = [];
export function animationDuration() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return 0;
  }

  return 100;
}
export function registerEvent(target, event, handler, opts) {
  target.addEventListener(event, handler, opts);
  eventDeregisterList.push(() => target.removeEventListener(event, handler, opts));
}
export function cleanState(exec) {
  let isTaskDone = false;
  var task = new Promise(async (resolve, reject) => {
    try {
      if (typeof exec === "function") await exec();
      isTaskDone = true;
      resolve();
    } catch (e) {
      reject(e);
      throw e;
    }
  });
  var animation = new Promise((resolve, reject) => {
    main.style.opacity = 0;
    main.style.filter = "grayscale(1)";
    main.style.pointerEvents = "none";
    eventDeregisterList.forEach(fn => fn());
    setTimeout(() => {
      delayAction(async () => {
        main.innerHTML = "";

        if (isTaskDone) {
          resolve();
          return;
        }

        main.appendChild(dom("div", {
          class: "loader-container",
          children: [dom("div", {
            class: "loader"
          })]
        }));
        delayAction(() => {
          main.style.opacity = "";
          main.style.filter = "";
          main.style.pointerEvents = "";
          setTimeout(() => {
            delayAction(() => {
              resolve();
            });
          }, animationDuration());
        });
      });
    }, animationDuration());
  });
  return new Promise((resolve, reject) => {
    function error(e) {
      main.innerHTML = "";
      main.appendChild(dom("div", {
        class: "error",
        children: [dom("h3", {
          textContent: "Помилка"
        }), dom("p", {
          textContent: e.message
        })]
      }));
    }

    var isTaskDone = false;
    var isAnimationDone = false;
    var er = null;
    task.then(() => {
      isTaskDone = true;

      if (er) {
        error(er);
        reject(er);
        return;
      }

      if (isAnimationDone) resolve();
    }).catch(e => {
      er = e;
      console.log("failed to clean state", e);
      error(e);
      reject(e);
    });
    animation.then(() => {
      isAnimationDone = true;

      if (er) {
        error(er);
        reject(er);
        return;
      }

      if (isTaskDone) resolve();
    }).catch(e => {
      er = e;
      error(e);
      reject(e);
    });
  });
}
export function clearStateAppear(exec) {
  return new Promise((resolve, reject) => {
    delayAction(() => {
      main.style.opacity = 0;
      main.style.filter = "grayscale(1)";
      main.style.pointerEvents = "none";
      setTimeout(() => {
        delayAction(async () => {
          main.innerHTML = "";

          try {
            if (typeof exec === "function") await exec();
            delayAction(() => {
              main.style.opacity = "";
              main.style.filter = "";
              main.style.pointerEvents = "";
            });
            resolve();
          } catch (e) {
            main.innerHTML = "";
            main.appendChild(dom("div", {
              class: "error",
              children: [dom("h3", {
                textContent: "Помилка"
              }), dom("p", {
                textContent: e.message
              })]
            }));
            delayAction(() => {
              main.style.opacity = "";
              main.style.filter = "";
              main.style.pointerEvents = "";
            });
            reject(e);
            throw e;
          }
        });
      }, animationDuration());
    });
  });
}